import React from "react";

const ReasignModal = ({ isOpen, onClose, onReasignTeam ,onReasignOtherTeam}) => {
  if (!isOpen) return null; 

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-red-500 text-2xl"
        >
          &times;
        </button>
        <div className="text-center mb-6 font-semibold text-lg text-gray-800">Reassign</div>

        <div className="flex flex-col gap-4 px-4">
          <div
            className="bg-customGreen cursor-pointer text-white font-medium text-center py-2 rounded-md"
            onClick={onReasignTeam}
          >
            Reassign to Team Member
          </div>
          <div
            className="bg-customGreen cursor-pointer text-white font-medium text-center py-2 rounded-md"
            onClick={onReasignOtherTeam}
          >
            Reassign to Other Team Members
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReasignModal;
